import { SigningMethodEnum } from '@dss-libs/shared/type/common-types';
import { IProviderMethod } from '@dss-libs/portal/type/portal-types';

export function isSignerAuthenticationRequired(
  signingMethods: readonly IProviderMethod[],
  signingMethod: SigningMethodEnum
): boolean {
  return signingMethods.some(
    ({ providerName, requiresAuthentication }) => providerName === signingMethod && requiresAuthentication
  );
}
